"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSitePrefix = void 0;
const VTB_HOSTS = ['rb.m2', 'm2.region.vtb.ru'];
const DEVENV_PORT = '9999';
const SITE_PREFIXES_BY_ENV_MAP = {
    development: 'https://dev-m2.ru',
    dev: 'https://dev-m2.ru',
    test: 'https://test-m2.ru',
    stage: 'https://stage-m2.ru',
    production: 'https://m2.ru',
    prod: 'https://m2.ru',
    perf: 'https://perf-m2.ru',
};
function getSitePrefix(appEnvironment, href) {
    if (href) {
        const url = new URL(href);
        const { host } = url;
        if (host.includes('localhost')) {
            url.port = DEVENV_PORT;
            return url.origin;
        }
        if (VTB_HOSTS.includes(host) || !SITE_PREFIXES_BY_ENV_MAP[appEnvironment]) {
            return url.origin;
        }
    }
    return SITE_PREFIXES_BY_ENV_MAP[appEnvironment];
}
exports.getSitePrefix = getSitePrefix;
//# sourceMappingURL=index.js.map